import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const Spinner = () => <FontAwesomeIcon icon={faSpinner} pulse fixedWidth />;

export default Spinner;
